import { Link, useLocation } from "react-router-dom";

import { SamphireLogo } from "../assets/logos/samphireLogo";
import SideDrawer from "../components/coreUI/SideDrawer";
import { useAuth } from "./providers/AuthProvider";

function Navigation() {
  const location = useLocation();
  const { user, signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <nav className="bg-canvas-base/95 text-foreground-primary sticky top-0 z-5 backdrop-blur-sm supports-backdrop-filter:bg-background/85">
      <div className="px-6 md:px-4 py-4 flex flex-row justify-between items-center">
        <Link to="/" className="cursor-pointer">
          <SamphireLogo width={100} className="text-foreground-primary" />
        </Link>
        {/* DEV ONLY */}
        {import.meta.env.DEV && (
          <div className="flex gap-4 text-sm">
            <p className="font-bold">⚠️ DEVELOPMENT NAV BAR ⚠️</p>
            <Link to="/purchase" className="cursor-pointer">
              <p>Purchase Flow</p>
            </Link>
            <Link to="/checkout/product/nettle" className="cursor-pointer">
              <p>Nettle OTP</p>
            </Link>
            <Link
              to="/checkout/subscription/$sn_nettle_12_mo"
              className="cursor-pointer"
            >
              <p>Nettle Monthly</p>
            </Link>
            <Link
              to="/checkout/subscription/$rc_annual"
              className="cursor-pointer"
            >
              <p>App Annual</p>
            </Link>
            <Link
              to="/checkout/subscription/$rc_monthly"
              className="cursor-pointer"
            >
              <p>App Monthly</p>
            </Link>
            <Link to="/stripe" className="cursor-pointer">
              <p>Stripe Plans</p>
            </Link>
            <Link to="/stripe-checkout" className="cursor-pointer">
              <p>Stripe Checkout</p>
            </Link>
            <Link to="/stripe-return" className="cursor-pointer">
              <p>Stripe Return</p>
            </Link>
          </div>
        )}
        <SideDrawer />
      </div>
    </nav>
  );
}

export default Navigation;
